import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
    Typography,
} from '@speeki/global-ui-components';

interface ConversationDetailsGoBackModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const ConversationDetailsGoBackModal = ({
    onClose,
    open,
}: ConversationDetailsGoBackModalProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ModalComponent
            onClose={onClose}
            open={open}
            preventCloseEsc
            preventCloseOutside
            width={648}
        >
            <Modal.Content>
                <Modal.TitleSecondary center>
                    {t('NEW_CONVERSATION_GO_BACK_TITLE')}
                </Modal.TitleSecondary>
                <Typography.TextBody_16_24>
                    {t('NEW_CONVERSATION_GO_BACK_DESCRIPTION')}
                </Typography.TextBody_16_24>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        onClick={onClose}
                        testId="button_cancel"
                        variant={'secondary'}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        onClick={() => {
                            onClose();
                            navigate(-1);
                        }}
                        testId="button_leave"
                        variant={'primary'}
                    >
                        {t('LEAVE')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
